import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EditableDescription from "../../utils-components/editable-description";
import { mapActions, mapState, mapGetters } from "vuex";
import { SAVE_DOCUMENT_CLASSIFICATION_DESCRIPTION, DELETE_DOCUMENT_CLASSIFICATION, UPLOAD_DOCUMENT_TO_CLASSIFICATION, MARK_DOCUMENT_CLASSIFICATIONS, UNMARK_DOCUMENT_CLASSIFICATIONS } from "../../../store/documents-actions";
import { documentStatusIcons } from "@Shared/@Utils/constants";
import { TOTAL_DOCUMENT_NEW_COMMENTS_BY_CLASSIFICATION } from "@Broker/@Modules/clients/applications/documents/store/documents-getters";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import { calculateFileSize } from "@Shared/@Utils/utils";
import { isEmpty } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentClassificationHeader",
  components: {
    EditableDescription,
    InlinePrompt
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    classification: {
      type: Object,
      required: true
    },
    totalDocuments: {
      type: Number,
      required: true
    },
    completedDocuments: {
      type: Number,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    showDropzone: {
      type: Boolean,
      default: false
    },
    files: {
      type: Array,
      default: () => []
    },
    documents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      savingDescription: false,
      uploadingDocuments: false,
      labelValue1: uuidv4(),
      labelValue2: uuidv4()
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("DocumentsStore", {
    markedDocumentClassifications(state) {
      return state.markedDocumentClassifications;
    }
  })), mapGetters("DocumentsStore", [TOTAL_DOCUMENT_NEW_COMMENTS_BY_CLASSIFICATION])), {}, {
    documentMarked: {
      get() {
        return this.markedDocumentClassifications[this.documentRequestId];
      },
      set(value) {
        if (value) this.markClassification();else this.unMarkClassification();
      }
    },
    documentRequestId() {
      return this.classification.documentRequestId;
    },
    classificationName() {
      return this.classification.classification;
    },
    counterClass() {
      if (!this.totalDocuments) return "";
      if (this.completedDocuments === this.totalDocuments) return "text-success";
      return "text-warning";
    },
    counterTooltipText() {
      if (!this.totalDocuments) return this.$t("documents.noDocumentsUploaded");
      if (this.completedDocuments === this.totalDocuments) return this.$t("documents.allDocumentsCompleted");
      return this.$t("documents.pendingDocuments");
    },
    description() {
      return this.classification.description;
    },
    noaIssue() {
      return this.classification.noaIssue;
    },
    sent() {
      return this.classification.sent;
    },
    requestedAt() {
      return this.classification.requestedAt;
    },
    formattedRequestedAt() {
      return this.$options.filters.formatDateHour(this.requestedAt);
    },
    isFileEmpty() {
      return isEmpty(this.files);
    },
    tooltipOptions() {
      return {
        disabled: !this.totalDocuments || this.uploadingDocuments,
        title: this.$t("documents.documentTypesWithUploadedDocumentsCannotBeDeleted")
      };
    },
    totalNewComments() {
      return this.TOTAL_DOCUMENT_NEW_COMMENTS_BY_CLASSIFICATION({
        applicationId: this.applicationId,
        classificationId: this.classification.documentRequestId
      });
    },
    visibleStatuses() {
      var _context, _context2, _context3;
      const statuses = new _Set(_filterInstanceProperty(_context = _mapInstanceProperty(_context2 = this.documents).call(_context2, doc => doc.requestStatus)).call(_context, status => !!status && documentStatusIcons[status]));
      return _mapInstanceProperty(_context3 = _Array$from(statuses)).call(_context3, status => ({
        status,
        icon: documentStatusIcons[status]
      }));
    }
  }),
  watch: {
    files(newValue) {
      if (!isEmpty(newValue)) this.handleConfirmUpload();
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [SAVE_DOCUMENT_CLASSIFICATION_DESCRIPTION, DELETE_DOCUMENT_CLASSIFICATION, UPLOAD_DOCUMENT_TO_CLASSIFICATION, MARK_DOCUMENT_CLASSIFICATIONS, UNMARK_DOCUMENT_CLASSIFICATIONS])), {}, {
    async handleSaveDescription({
      description
    }) {
      this.savingDescription = true;
      await this.SAVE_DOCUMENT_CLASSIFICATION_DESCRIPTION({
        documentRequestId: this.documentRequestId,
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        description
      });
      this.savingDescription = false;
    },
    async handleDeleteDocumentClassification() {
      this.unMarkClassification();
      await this.DELETE_DOCUMENT_CLASSIFICATION({
        documentRequestId: this.documentRequestId,
        applicationId: this.applicationId,
        clientUsername: this.clientUsername
      });
    },
    async handleFilesSelected(event) {
      const files = event.target.files;
      if (!(files != null && files.length)) return;
      if (!this.showDropzone) {
        this.uploadingDocuments = true;
        await this.uploadDocumentsToClassification(files);
        this.$refs.fileInput.value = "";
        this.uploadingDocuments = false;
      } else {
        this.$emit("add-files", files);
      }
    },
    async handleConfirmUpload() {
      this.$emit("disabled", true);
      this.uploadingDocuments = true;
      await this.uploadDocumentsToClassification(this.files);
      this.clearFiles();
      this.uploadingDocuments = false;
      this.$emit("disabled", false);
    },
    async uploadDocumentsToClassification(files) {
      await this.UPLOAD_DOCUMENT_TO_CLASSIFICATION({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        classification: this.classification,
        files
      });
    },
    markClassification() {
      this.MARK_DOCUMENT_CLASSIFICATIONS({
        markedDocumentClassifications: [this.documentRequestId]
      });
    },
    unMarkClassification() {
      this.UNMARK_DOCUMENT_CLASSIFICATIONS({
        markedDocumentClassifications: [this.documentRequestId]
      });
    },
    clearFiles() {
      this.$emit("clear-files");
    },
    getFileSize(size) {
      return calculateFileSize(size);
    }
  })
});